import { useEffect, useState, } from 'react';
import theme from '../../styles/theme';
import windowMatchMedia from '../../utils/windowMatchMedia';
const breakpointNames = (Object
    .keys(theme
    .breakpoints));
const breakpointValues = (theme
    .breakpointsList
    .map(({ breakpointValue, }) => (breakpointValue)));
const useMediaQuery = (localWindow = (typeof window === 'undefined'
    ? undefined
    : window)) => {
    const [currentMediaQuery, setCurrentMediaQuery,] = useState('');
    useEffect(() => {
        const callback = (mediaQuery //= {media: '', matches: false, onchange: () => {}, addListener: ()=>{},removeListener: ()=>{},addEventListener: ()=>{},removeEventListener: ()=>{},dispatchEvent: ()=>false, } // HTMLMetaElement //HTMLElement
        ) => {
            var _a;
            if (!mediaQuery || !mediaQuery.matches) {
                return;
            }
            setCurrentMediaQuery(((_a = theme
                .breakpointsList
                .find(({ breakpointValue, }) => (Object.is((String(breakpointValue)), (mediaQuery
                .media
                .replace(/^.*min-width: (.*?)px.*$/, '$1')))))) === null || _a === void 0 ? void 0 : _a.breakpointName)
                || '');
        };
        const mediaQueries = (breakpointValues
            .map((breakpointValue, index) => (localWindow === null || localWindow === void 0 ? void 0 : localWindow.matchMedia(index === breakpointValues.length - 1
            ? `(min-width: ${breakpointValue}px)`
            : (`(min-width: ${breakpointValue}px)`
                .concat(' and ')
                .concat(`(max-width: ${breakpointValues[index + 1] - 1}px)`)))))
            .filter(Boolean));
        mediaQueries
            .forEach((mediaQuery) => {
            windowMatchMedia.addListener(mediaQuery, callback);
            callback(mediaQuery);
        });
        return () => {
            mediaQueries
                .forEach((mediaQuery) => {
                windowMatchMedia.removeListener(mediaQuery, callback);
            });
        };
    }, [
        localWindow,
        setCurrentMediaQuery,
    ]);
    return currentMediaQuery;
};
useMediaQuery.breakpointNames = breakpointNames;
export default useMediaQuery;
